import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';
import SideNav from './SideNav';
import Footer from './Footer';
import PageHeader from './PageHeader';
import './Common.css';
import './CulturalInsights.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/lb-api';

const CIChatHistory = ({ user }) => {
  const [conversations, setConversations] = useState([]);
  const [selectedConv, setSelectedConv] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const breadcrumbs = [
    { label: 'Home', path: '/', current: false },
    { label: 'Explore Learning', path: '/explore-learning', current: false },
    { label: 'Cultural Insights', path: '/cultural-insights', current: false },
    { label: 'Chat History', current: true }
  ];

  useEffect(() => {
    axios.get(`${API_BASE_URL}/cultural-insights/history`, { withCredentials: true })
      .then(res => {
        if (res.data.success) setConversations(res.data.conversations || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const loadMessages = (conv) => {
    setSelectedConv(conv.conversation_id);
    setMessages([]);
    axios.get(`${API_BASE_URL}/cultural-insights/history/${conv.conversation_id}`, { withCredentials: true })
      .then(res => {
        if (res.data.success) setMessages(res.data.messages || []);
      })
      .catch(err => console.error('Load messages error:', err));
  };

  const deleteConv = (convId, e) => {
    e.stopPropagation();
    if (!window.confirm('Delete this conversation?')) return;
    axios.delete(`${API_BASE_URL}/cultural-insights/history/${convId}`, { withCredentials: true })
      .then(() => {
        setConversations(prev => prev.filter(c => c.conversation_id !== convId));
        if (selectedConv === convId) { setSelectedConv(null); setMessages([]); }
      })
      .catch(err => console.error('Delete error:', err));
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) + ' ' + d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="ci-page">
      <Header user={user} />
      <div className="nav-header-container">
        <SideNav />
        <PageHeader breadcrumbs={breadcrumbs} language="de" proficiencyLevel="beginner-a1" onLanguageChange={() => {}} onLevelChange={() => {}} rightContent={<></>} />
      </div>

      <main className="ci-history-content">
        <div className="ci-history-sidebar">
          <h3 className="ci-history-title">Chat History</h3>
          {loading && <p className="ci-history-empty">Loading...</p>}
          {!loading && conversations.length === 0 && <p className="ci-history-empty">No conversations yet</p>}
          {conversations.map(c => (
            <div key={c.conversation_id} className={`ci-history-item${selectedConv === c.conversation_id ? ' active' : ''}`} onClick={() => loadMessages(c)}>
              <div className="ci-history-item-top">
                <span className="ci-history-item-title">{c.title || c.category || 'Cultural Insights'}</span>
                <button className="ci-history-delete" onClick={(e) => deleteConv(c.conversation_id, e)}>&times;</button>
              </div>
              <div className="ci-history-item-meta">
                <span>{c.country}</span>
                {c.category && <span> · {c.category}</span>}
                <span> · {formatDate(c.last_message_at || c.started_at)}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="ci-history-messages">
          {!selectedConv && <p className="ci-history-empty">Select a conversation to view</p>}
          {selectedConv && messages.length === 0 && <p className="ci-history-empty">No messages found</p>}
          {messages.map((m, i) => {
            let fullResp = null;
            if (m.full_response) {
              try { fullResp = JSON.parse(m.full_response); } catch(e) {}
            }
            return (
              <div key={m.message_id || i} className={`ci-history-msg ${m.role}`}>
                {m.role === 'user' ? (
                  <div className="ci-history-msg-user">
                    <span className="ci-history-msg-text">{m.message_text}</span>
                  </div>
                ) : (
                  <div className="ci-history-msg-bot">
                    <div className="ci-bot-avatar"><span>LB</span></div>
                    <div className="ci-history-bot-content">
                      <p className="ci-history-msg-text">{m.message_text}</p>
                      {fullResp?.subcategories && fullResp.subcategories.length > 0 && (
                        <div className="ci-history-topics">
                          {fullResp.subcategories.map((topic, ti) => (
                            <div key={ti} className="ci-history-topic-row">{topic}</div>
                          ))}
                        </div>
                      )}
                      {fullResp?.categories && fullResp.categories.length > 0 && !fullResp?.subcategories && (
                        <div className="ci-history-categories">
                          {fullResp.categories.map((cat, ci) => (
                            <div key={ci} className="ci-history-category-item">
                              <strong>{cat.name}:</strong> {cat.description}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CIChatHistory;
